<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots || {};

  // set of options. structure: [{ label: "a", value: "a" }]
  export let placeholder;
  export let options = [];
  export let disabled = false;
  export let showSelectedOption = false;
  export let selectedOption = options[0];
  export let optionsVisible = false;

  let hideOptions = function () {
    optionsVisible = false;
  };

  let showOptions = function () {
    optionsVisible = true;
  };

  let toggleOptions = function () {
    if (optionsVisible) {
      hideOptions();
    } else {
      showOptions();
    }
  };

  let selectOption = function (option) {
    hideOptions();
    placeholder = undefined;
    selectedOption = option;
    dispatch('selected', { option: option });
  };
</script>

<style style="text/scss" lang="scss">
  .dropdown {
    position: relative;
    border-radius: 15px;

    .dropdown-button {
      width: 100%;
      text-align: left;
      border-radius: 15px;
      background: transparent;
      font-size: 14px;
      color: black;
      font-weight: 500;
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: 24px;
      padding-right: 24px;
      border: 0px;
      transition: all 0.2s ease-in-out;
      display: flex;
      cursor: pointer;

      &:hover {
        color: #a893f9;
      }
    }

    .dropdown-options {
      top: 40px;
      position: absolute;
      left: 0px;
      right: 0px;
      margin-top: -7px;
      padding-top: 7px;
      background: white;
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      padding-bottom: 8px;
      display: flex;
      flex-direction: column;
      padding-left: 24px;
      padding-right: 24px;

      .dropdown-options-option {
        padding-top: 8px;
        padding-bottom: 8px;
        font-weight: normal;
        opacity: 0.9;

        &:hover {
          color: #a893f9;
        }
      }
    }
  }

  .dropdown-downarrow-container {
    svg {
      -webkit-transform: rotate(-180deg);
      transform: rotate(-180deg);
    }
  }

  .dropdown-visible {
    box-shadow: 0 48px 125px rgba(0, 0, 0, 0.15);
    z-index: 99;

    .dropdown-button {
      background: white;
      transition: none;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .disabled {
    opacity: 0.5;
  }
</style>

{#if optionsVisible}
  <div class="backdrop {$$props.backdropClass}" on:click|preventDefault|stopPropagation={hideOptions} />
{/if}

<div class="dropdown {$$props.class}" class:dropdown-visible={optionsVisible}>
  <button
    class="dropdown-button {$$props.buttonClass}"
    type="button"
    disabled={disabled}
    class:disabled={disabled}
    on:click|preventDefault|stopPropagation={toggleOptions}>
    <div style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class={$$props.labelClass}>
      {#if SLOTS.selectedContent}
        <slot name="selectedContent" option={selectedOption} />
      {:else}
        {placeholder || selectedOption.label}
      {/if}
    </div>
    <div
      style="flex-shrink: 0; margin-left: 14px;"
      class:dropdown-uparrow-container={optionsVisible}
      class:dropdown-downarrow-container={!optionsVisible}>
      <svg
        class={$$props.arrowClass}
        style="transition: 0.2s"
        width="11"
        height="7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M10 6L5.5 1 1 6" stroke="#A893F9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </button>
  {#if optionsVisible}
    <div class="dropdown-options {$$props.optionsClass}">
      {#each options as option}
        {#if showSelectedOption || placeholder || selectedOption.value != option.value}
          <a
            on:click|preventDefault={() => {
              selectOption(option);
            }}
            class="dropdown-options-option {$$props.optionClass}"
            href="#">
            {#if SLOTS.optionContent}
              <slot name="optionContent" option={option} />
            {:else}{option.label}{/if}
          </a>
        {/if}
      {/each}
      <slot name="additional-options" />
    </div>
  {/if}
</div>
